/* Inspired theme extras: add-on tick box, cart drawer upsells, sticky mobile buy bar. */
(function () {
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function sectionInner(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  function updateBubble(sections) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections && sections['cart-icon-bubble']) {
      bubble.innerHTML = sectionInner(sections['cart-icon-bubble']);
    }
  }

  async function addVariant(id, sections) {
    const res = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'Could not add to cart');
    return data;
  }

  async function removeVariant(id, sections) {
    const res = await fetch(`${window.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ id: String(id), quantity: 0, sections: sections }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'Could not update cart');
    return data;
  }

  /* Cart: setting a quantity to 0 removes the item (Dawn otherwise blocks it with a "minimum 1" check) */
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!input.matches || !input.matches('cart-items .quantity__input, cart-drawer-items .quantity__input')) return;
      if (parseInt(input.value, 10) !== 0) return;
      const list = input.closest('cart-items, cart-drawer-items');
      const index = input.dataset.index;
      const remove = list && list.querySelector(`cart-remove-button[data-index="${index}"]`);
      if (!remove) return;
      event.stopImmediatePropagation();
      remove.click();
    },
    true
  );

  /* Add-on tick box on product pages */
  document.addEventListener('change', async (event) => {
    const box = event.target.closest('[data-ins-addon]');
    if (!box) return;
    const wrap = box.closest('.ins-addon');
    const status = wrap && wrap.querySelector('[data-ins-addon-status]');
    box.disabled = true;
    try {
      const data = box.checked
        ? await addVariant(box.dataset.variantId, ['cart-icon-bubble'])
        : await removeVariant(box.dataset.variantId, ['cart-icon-bubble']);
      updateBubble(data.sections);
      if (status) status.textContent = box.checked ? 'Added to your cart' : 'Removed';
    } catch (err) {
      box.checked = !box.checked;
      if (status) status.textContent = err.message;
    } finally {
      box.disabled = false;
    }
  });

  /* "Complete your set" add buttons inside the cart drawer */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-ins-upsell-add]');
    if (!btn) return;
    event.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding…';
    const drawer = document.querySelector('cart-drawer');
    try {
      const data = await addVariant(btn.dataset.variantId, ['cart-drawer', 'cart-icon-bubble']);
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: Number(btn.dataset.variantId), sections: data.sections });
      } else {
        updateBubble(data.sections);
        btn.textContent = 'Added';
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Add';
    }
  });

  /* Sticky add-to-cart bar for phones */
  function initSticky() {
    const bar = document.querySelector('[data-ins-sticky]');
    if (!bar) return;
    const mainButton = document.querySelector('product-info form[data-type="add-to-cart-form"] [type="submit"], .product-form__submit');
    if (!mainButton) return;
    bar.hidden = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(mainButton);

    const stickyBtn = bar.querySelector('[data-ins-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (mainButton.disabled) {
          mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainButton.click();
      });
    }
  }

  /* Cart drawer extras: copy reward bar, "Complete your set" and trust row into the drawer */
  function extrasSource() {
    return document.querySelector('[data-ins-cart-extras]');
  }

  function extrasSectionId() {
    const src = extrasSource();
    const wrap = src && src.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function injectExtras() {
    const drawer = document.querySelector('cart-drawer');
    const src = extrasSource();
    if (!drawer || !src) return;
    drawer.querySelectorAll('[data-ins-injected]').forEach((el) => el.remove());

    const place = (part, target, where) => {
      const piece = src.querySelector(`[data-part="${part}"]`);
      if (!piece || !target || !piece.innerHTML.trim()) return;
      const clone = piece.cloneNode(true);
      clone.removeAttribute('data-part');
      clone.setAttribute('data-ins-injected', '');
      target.insertAdjacentElement(where, clone);
    };

    place('reward', drawer.querySelector('.drawer__contents'), 'afterbegin');
    place('upsell', drawer.querySelector('.drawer__cart-items-wrapper'), 'afterend');
    place('trust', drawer.querySelector('.cart__ctas'), 'beforeend');
  }

  async function refreshExtras() {
    const id = extrasSectionId();
    if (!id) return;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}?section_id=${encodeURIComponent(id)}`);
      const html = await res.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ins-cart-extras]');
      const current = extrasSource();
      if (fresh && current) current.replaceWith(fresh);
    } catch (e) {
      /* keep the last good version */
    }
    injectExtras();
  }

  function initCartExtras() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !extrasSource()) return;
    injectExtras();
    let timer;
    const observer = new MutationObserver((mutations) => {
      const external = mutations.some((m) =>
        Array.from(m.addedNodes).some(
          (n) => n.nodeType === 1 && !n.hasAttribute('data-ins-injected') && !(n.closest && n.closest('[data-ins-injected]'))
        )
      );
      if (!external) return;
      clearTimeout(timer);
      timer = setTimeout(refreshExtras, 150);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  /* Upgrade choice: picking the bundle makes the main Add to cart add the bundle */
  function applyOption(radio) {
    const scope = radio.closest('.shopify-section') || document;
    const form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('product-form form');
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = radio.value;
    const btnText = form.querySelector('[name="add"] > span');
    if (btnText) {
      if (!btnText.dataset.insDefault) btnText.dataset.insDefault = btnText.textContent.trim();
      btnText.textContent = radio.dataset.label || btnText.dataset.insDefault;
    }
  }

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-ins-opt]');
    if (radio && radio.checked) applyOption(radio);
  });

  function initOptions() {
    document.querySelectorAll('[data-ins-opt]:checked').forEach(applyOption);
  }

  function init() {
    initSticky();
    initCartExtras();
    initOptions();
  }

  window.addEventListener('pageshow', initOptions);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
